import { Flow } from "../types/IFlow";
import {
  NoConfirmationDefaultNavigatorConfiguration,
  NoConfirmationPreQualifiedPatientNavigatorConfiguration
} from "./NavigatorConfigurations";
import {
  noConfirmationCenterSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "./StepConfigurations";

const noConfirmationNewPatientFlowName = "NoConfirmationNewPatientFlow";
const legacyNewPatientFlowNames = ["newPatient"];

/** The flow that a new patient should experience when booking without a confirmation step. */
class NoConfirmationNewPatientFlow extends Flow {
  static readonly flowName = noConfirmationNewPatientFlowName;
  readonly name = noConfirmationNewPatientFlowName;
  readonly steps = { ...screeningStepConfigurations, ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = NoConfirmationDefaultNavigatorConfiguration;
  isDisqualificationPossible() {
    return true;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || legacyNewPatientFlowNames.includes(name);
  }
}

/** The flow that a pre-qualified new patient should experience when booking without a confirmation step. */
export class PreQualifiedNoConfirmationNewPatientFlow extends Flow {
  readonly name = noConfirmationNewPatientFlowName;
  readonly steps = { ...noConfirmationCenterSelectableBookingStepConfigurations };
  readonly navigatorItems = NoConfirmationPreQualifiedPatientNavigatorConfiguration;
  isDisqualificationPossible() {
    return false;
  }

  override matchesFlowName(name: string): boolean {
    return name === this.name || legacyNewPatientFlowNames.includes(name);
  }
}

export default NoConfirmationNewPatientFlow;
